import { Model } from '../Model.js';

var _dec, _class;

/**
 * All possible client types gathered in an enum
 *
 */
let ClientType = /*#__PURE__*/function (ClientType) {
  ClientType["AUTONOMOUS"] = "AUTONOMOUS";
  ClientType["BUSINESS"] = "BUSINESS";
  ClientType["OTHERS"] = "OTHERS";
  ClientType["UNKNOWN"] = "UNKNOW";
  return ClientType;
}({});

/**
 * Plain object Client representation.
 *
 */

/**
 * Serialized object Client representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

/**
 * Plain object Packlink's API PUT payload representation.
 *
 */

/**
 * Plain object Packlink's API PUT response.
 *
 */

let Client = (_dec = Model(), _dec(_class = class Client {
  /**
   * Takes a IClientApiResponse from Packlink's API and returns a Client.
   *
   * @param response  IClientApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    var _response$phone_numbe;
    return new Client(response.allow_deferred, response.country, response.created_at, response.debtor, response.deferred_payment_blocked, response.direct_debit_requested, response.email, response.identifier, response.language, response.phone,
    // 'UNKNOW' is a historical typo in the API
    ClientType[response.customer_type === 'UNKNOW' ? 'UNKNOWN' : response.customer_type] || undefined, response.name || undefined, response.surname || undefined, response.postal_code || undefined, response.city || undefined, response.address || undefined, response.address2 || undefined, response.company_name || undefined, response.location || undefined, response.state || undefined, response.tax_id || undefined, (_response$phone_numbe = response.phone_number_verified) !== null && _response$phone_numbe !== void 0 ? _response$phone_numbe : false);
  }

  /**
   * Takes a serialized Client and returns a Client.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Client.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedClient.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Client.
   *
   */

  /**
   * Takes a serialized Client and returns a Client.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Client.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedClient.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Client.
   *
   */

  /**
   * Takes a serialized Client and returns a Client.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Client.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedClient.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Client.
   *
   */

  /**
   * Takes a serialized Client and returns a Client.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Client.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedClient.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Client.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new Client(data.allowDeferred, data.alpha2Code, data.createdAt, data.debtor, data.deferredPaymentBlocked, data.directDebitRequested, data.email, data.id, data.language, data.phone, data.type, data.firstName, data.lastName, data.zipCode, data.city, data.address, data.address2, data.companyName, data.location, data.state, data.taxId, data.phoneNumberVerified);
  }

  /**
   * Returns a new Client. Typings of the properties depend on the class type param T
   *
   */
  constructor(allowDeferred, alpha2Code, createdAt, debtor, deferredPaymentBlocked, directDebitRequested, email, id, language, phone, type, firstName, lastName, zipCode, city, address, address2, companyName, location, state, taxId, phoneNumberVerified) {
    this.allowDeferred = allowDeferred;
    this.alpha2Code = alpha2Code;
    this.createdAt = createdAt;
    this.debtor = debtor;
    this.deferredPaymentBlocked = deferredPaymentBlocked;
    this.directDebitRequested = directDebitRequested;
    this.email = email;
    this.id = id;
    this.language = language;
    this.phone = phone;
    this.type = type;
    this.firstName = firstName;
    this.lastName = lastName;
    this.zipCode = zipCode;
    this.city = city;
    this.address = address;
    this.address2 = address2;
    this.companyName = companyName;
    this.location = location;
    this.state = state;
    this.taxId = taxId;
    this.phoneNumberVerified = phoneNumberVerified;
  }

  /**
   * Returns a JSON serialized version of the Client.
   *
   */
  toJSON() {
    return {
      address: this.address,
      address2: this.address2,
      allowDeferred: this.allowDeferred,
      alpha2Code: this.alpha2Code,
      city: this.city,
      companyName: this.companyName,
      createdAt: this.createdAt,
      debtor: this.debtor,
      deferredPaymentBlocked: this.deferredPaymentBlocked,
      directDebitRequested: this.directDebitRequested,
      email: this.email,
      firstName: this.firstName,
      id: this.id,
      language: this.language,
      lastName: this.lastName,
      location: this.location,
      phone: this.phone,
      phoneNumberVerified: this.phoneNumberVerified,
      state: this.state,
      taxId: this.taxId,
      type: this.type,
      zipCode: this.zipCode
    };
  }

  /**
   * Returns a clone of the Client.
   *
   */
  clone() {
    return new Client(this.allowDeferred, this.alpha2Code, this.createdAt, this.debtor, this.deferredPaymentBlocked, this.directDebitRequested, this.email, this.id, this.language, this.phone, this.type, this.firstName, this.lastName, this.zipCode, this.city, this.address, this.address2, this.companyName, this.location, this.state, this.taxId, this.phoneNumberVerified);
  }

  /**
   * Returns whether the two Client are equal.
   *
   */
  equals(client) {
    if (!client) {
      return false;
    }
    return this.allowDeferred === client.allowDeferred && this.alpha2Code === client.alpha2Code && this.createdAt === client.createdAt && this.debtor === client.debtor && this.deferredPaymentBlocked === client.deferredPaymentBlocked && this.directDebitRequested === client.directDebitRequested && this.email === client.email && this.firstName === client.firstName && this.id === client.id && this.language === client.language && this.lastName === client.lastName && this.phone === client.phone && this.phoneNumberVerified === client.phoneNumberVerified && this.type === client.type && this.zipCode === client.zipCode && this.city === client.city && this.address === client.address && this.address2 === client.address2 && this.companyName === client.companyName && this.location === client.location && this.state === client.state && this.taxId === client.taxId;
  }

  /**
   * Returns a JSON with the payload necessary to update a Client.
   *
   */
  getUpdatePayload() {
    return {
      address: this.address,
      address2: this.address2,
      allow_deferred: this.allowDeferred,
      city: this.city,
      company_name: this.companyName,
      country: this.alpha2Code,
      created_at: this.createdAt,
      customer_type: this.type,
      debtor: this.debtor,
      deferred_payment_blocked: this.deferredPaymentBlocked,
      direct_debit_requested: this.directDebitRequested,
      email: this.email,
      identifier: this.id,
      language: this.language,
      location: this.location,
      name: this.firstName,
      phone: this.phone,
      postal_code: this.zipCode,
      state: this.state,
      surname: this.lastName,
      tax_id: this.taxId
    };
  }
  isAutonomousClient() {
    return this.type === ClientType.AUTONOMOUS;
  }
  isBusinessClient() {
    return this.taxId && this.taxId !== '-' && this.type === ClientType.BUSINESS;
  }
  isInvoiceAddressValid() {
    return this.isAutonomousClient() || this.isBusinessClient();
  }
}) || _class);

export { Client, ClientType };
//# sourceMappingURL=Client.js.map
